export default function Contact() {
  return (
    <>
      <section className="hero text-white">
        <div className="row g-3 align-items-center">
          <div className="col-lg-8">
            <div className="badge-soft mb-2">Say hello</div>
            <h1 className="display-6 fw-bold">
              We’d love to hear how you’d adapt PulseFrame for your brand.
            </h1>
            <p className="lead">Drop a note. We’ll respond within one business day (fictional SLA).</p>
          </div>
          <div className="col-lg-4 text-lg-end">
            <div className="pill">
              <i className="bi bi-envelope"></i> contact@pulseframe.test
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="row g-4">
          <div className="col-md-7">
            <div className="glass-card h-100">
              <h5 className="mb-3">Send a message</h5>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="mb-3">
                  <label className="form-label" htmlFor="name">
                    Name
                  </label>
                  <input className="form-control" id="name" type="text" placeholder="Alex Doe" />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="email">
                    Email
                  </label>
                  <input className="form-control" id="email" type="email" placeholder="you@example.com" />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="topic">
                    Topic
                  </label>
                  <select className="form-select" id="topic">
                    <option>Partnership</option>
                    <option>Pricing</option>
                    <option>Design tweaks</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows={4}
                    placeholder="Tell us what you need"
                  ></textarea>
                </div>
                <button type="submit" className="cta-btn primary">
                  Send it
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-5">
            <div className="glass-card h-100">
              <h5 className="mb-3">Offices</h5>
              <p className="text-muted">
                Distributed by design. We work across time zones and meet online first.
              </p>
              <div className="pill mb-2">
                <i className="bi bi-geo-alt"></i> Remote · Global
              </div>
              <div className="pill mb-2">
                <i className="bi bi-clock"></i> Response within 24h
              </div>
              <p className="text-muted mb-0">
                Want to embed PulseFrame? Grab the SPA bundle and go—no ops ticket required.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
